let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("g5R8w")).then(() => parcelRequire('6r800'));